import { render, staticRenderFns } from "./RemindReservatoinModal.vue?vue&type=template&id=2074dfb7&lang=pug"
import script from "./RemindReservatoinModal.vue?vue&type=script&lang=ts"
export * from "./RemindReservatoinModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports